<template>
  <div class="forgot-password">
    <ValidationObserver v-slot="{ invalid }">
      <div class="register-cta">
        <h2 class="auth-title">Восстановление пароля</h2>
        <p class="action-text">Введите адрес электронной почты, связанный с вашим аккаунтом.</p>
      </div>
      <p style=" color: #FCFCFD; margin-bottom: 10px">Электронная почта</p>
      <BaseInput
        v-if="!token"
        v-model="email"
        rules="required|email"
        :placeholder="$t('auth.email')"
        type="email"
      />
      <BaseInput
        v-else
        v-model="password"
        rules="required"
        :placeholder="$t('auth.password')"
        type="password"
      />
      <div class="action-btn">
        <p style="color: #999999; font-size: 14px" >Мы направим вам ссылку по электронной почте. Пожалуйста, перейдите по ней, чтобы завершить восстановление
          пароля.</p>
        <BaseButton
          btnColor="gold"
          :disabled="invalid"
          :label="buttonLabel"
          @setAction="setAction"
        />
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import BaseButton from '../base/BaseButton.vue'
import BaseInput from '../base/BaseInput.vue'

export default {
  components: {BaseInput, BaseButton},

  props: {
    token: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      email: '',
      password: ''
    }
  },

  computed: {
    buttonLabel() {
      if (this.token) return this.$t('auth.changePassword')
      return this.$t('auth.sendCode')
    }
  },

  methods: {
    setAction() {
      if (this.token) {
        this.setNewPassword()
      } else {
        this.resetPassword()
      }
    },
    async setNewPassword() {
      try {
        const data = {
          token: this.token,
          password: this.password
        }
        await this.$api.user.setNewPassword(data)
        this.$store.dispatch('updateModalStatus', {
          status: true,
          name: 'success'
        })
        this.$emit('setLogin')
        this.$router.replace({'query': null})
      } catch (e) {
        this.$store.dispatch('updateModalStatus', {
          status: true,
          name: 'error',
          message: e
        })
      }
    },
    async resetPassword() {
      try {
        this.$store.dispatch('updateLoading', true)
        await this.$api.user.resetPassword(this.email)
        this.$store.dispatch('updateModalStatus', {
          status: true,
          name: 'success',
          message: this.$t('auth.checkYourEmail')
        })
        this.email = ''
      } catch (e) {
        this.$store.dispatch('updateModalStatus', {
          status: true,
          name: 'error',
          message: e
        })
      } finally {
        this.$store.dispatch('updateLoading', false)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/auth/forgot_password.scss';
</style>



// WEBPACK FOOTER //
// src/components/auth/ForgotPassword.vue